<template>
    <div :class="['totem-sign-up-tag', {'red': isRedTag }]">
        <span v-if="!isSignedUpToDigitalClassRoomEvent" class="icon-exclamation-circle"></span>
        <span v-else class="icon-checkmark"></span>
        <span v-html="getSignedUpToDigitalClassroomLabel"></span>
    </div>
</template>

<script>
import CourseItemHelper from 'components/shared/global-courses-items/helper/course-item-helper'

export default {
    name: 'totem-sign-up-tag',
    props: {
        course: Object,
        useRedTag: {
            type: Boolean,
            default: false
        }
    },
    mixins: [ CourseItemHelper ],
    computed: {
        isRedTag () {
            return this.useRedTag && !this.isSignedUpToDigitalClassRoomEvent
        }
    }
}
</script>

<style lang="scss" scoped>
    .totem-sign-up-tag {
        display: inline-flex;
        align-items: center;
        align-self: flex-start;
        padding: 0 12px;
        margin: 0 6px 6px 0;
        border-radius: 3px;
        height: 22px;
        font-size: 1.4rem;
        position: relative;
        background: $bright_gray;
        color: $black;

        &.red {
            background: $chestnut;
            color: $white;

            .icon-exclamation-circle {
                color: $white;
            }
        }

        .icon-exclamation-circle,
        .icon-checkmark {
            font-size: 1.4rem;
            margin-right: 6px;
        }

        .icon-exclamation-circle {
            color: $orange;
        }

        .icon-checkmark {
            color: $ocean_green;
        }
    }
</style>
